<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import ChartEnergyEfficiency from '$lib/PageSections/Charts/ChartEnergyEfficiency/ChartEnergyEfficiency.svelte';
	import CustomerStory from '$lib/PageSections/CustomerStory/CustomerStory.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import ProductRecommendation from '$lib/PageSections/Products/ProductRecommendation.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import TrustedChoice from '$lib/PageSections/TrustedChoice/TrustedChoice.svelte';

	import { PrivacyProduct } from '$lib/data/products/products-data.js';
	import { privacyCustomerStory } from '$routes/(public)/resources/case-studies/customer-stories.js';

	import installingTintImage from './images/installingTint.jpg';
</script>

<Section>
	<h2 class="text-left">Add Easy-To-Remove Privacy To Any Window</h2>
	<p class="text-left">
		Adding privacy to sensitive areas of your home can be a simple process.
		Window films are affordable - though difficult to apply - and prevent any
		lurking eyes from seeing into your home, while still allowing natural light
		to penetrate. But what if you don't want your windows obscured all of the
		time? Once the film is applied, it stays there and cannot be easily removed
		and reapplied.
	</p>

	<Image src={installingTintImage} loading="eager" />

	<h2 class="text-left">Window Privacy On Your Terms</h2>
	<p class="text-left">
		Like some window films, <a href="/products/privacy-inserts"
			>Indow Privacy Inserts</a
		> obscure visibility into your home, without blocking natural light, allowing
		you to enjoy brightly lit spaces without worrying about the prying gaze of onlookers.
	</p>
	<p class="text-left">
		Unlike window films, our privacy grade inserts are extremely easy to insert
		and remove into your windows - giving you control over when you have the
		added privacy and when you're enjoying the view outside.
	</p>
</Section>

<CustomerStory story={privacyCustomerStory} />

<Section>
	<h2 class="text-left">More Quiet, More Comfort, More Savings</h2>
	<p class="text-left">
		In addition to blocking visibility, <a href="/products/privacy-inserts"
			>Indow Privacy Inserts</a
		>
		also provide significant
		<a href="/solutions/noise-performance">noise reduction</a>
		- keeping your home up to 50% quieter - and keeping your home's temperature more
		stable,
		<a href="/solutions/lower-energy-bills"
			>reducing energy use an average of 20%</a
		>. It's a win-win-win for your pocket book, the planet, and your privacy.
	</p>
	<p class="text-left">
		Our air-tight seal not only keeps noise out and your ideal temperature in,
		but it also <a href="/solutions/prevent-window-condensation"
			>reduces condensation</a
		>
		and
		<a href="/solutions/block-pollen-and-pollutants"
			>blocks dust, pollen, and other airborne particles</a
		>. But that doesn't mean you'll have to live in a hermetically sealed home!
		With a gentle tug on the provided D-ring, you can break the seal and remove
		the inserts whenever you want to open your windows and let in some fresh
		air.
	</p>
</Section>

<ProductRecommendation product={PrivacyProduct} />

<Section backgroundColor="grey-light">
	<h3 class="text-indow-grey-dark">Indow vs Replacement Windows</h3>
	<p>
		Adding Indow inserts to an existing window can make your windows perform as
		well (or better!) than a replacement window, but at a fraction of the cost
		and without the hassle and disruption of installing new windows.
	</p>
	<ChartEnergyEfficiency />
</Section>

<TrustedChoice />
<Reviews />
<GetAFreeEstimate />
